import { createSlice } from '@reduxjs/toolkit';
import { UniversalButtonState } from '~/types/universalButton';

export const initialState: UniversalButtonState = {
  universalButtonData: null,
  loadingString: '',
  loading: false
};

const universalButtonSlice = createSlice({
  name: 'universalButton',
  reducers: {
    loader: (state, action) => {
      state.loading = true;
      state.loadingString = action.payload.loadingString ?? state.loadingString;
    },
    hideLoader: (state) => {
      state.loading = false;
    },
    setUniversalButtonData: (state, action) => {
      state.universalButtonData = action.payload;
    }
  },
  initialState
});

export const { loader, setUniversalButtonData, hideLoader } =
  universalButtonSlice.actions;

export default universalButtonSlice.reducer;
